// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"0":"81f09a27","202":"cfebca94","274":"8ca5e8a0","427":"8563927a","985":"bafdbee6"}[chunkId] + ".chunk.js";
};